// extracted by mini-css-extract-plugin
module.exports = {"container":"FRtMrafVqLxb1GC-EP90z","value":"_16KB3Y-9YJ1PL3bF37aKla","smallText":"jjxYjYZrdTBUnVTqWdd94","unit":"_32xTKQTiZgvC9BgSzOZA_z"};